import createReducer from 'utils/createReducer';

const actionTypes = {
  init: 'init',
  setBannedParkingEmployees: 'setBannedParkingEmployees',
  setCurrentPage: 'setCurrentPage',
  setTotalPages: 'setTotalPages',
  setCurrentSearch: 'setCurrentSearch',
  setCurrentStatus: 'setCurrentStatus'
};

const initialState = {
  bannedParkingEmployees: [],
  currentPage: 0,
  totalPages: 0,
  currentSearch: '',
  currentStatus: ''
};

const parkingBansReducer = createReducer(initialState, {
  [actionTypes.init]: () => initialState,
  [actionTypes.setBannedParkingEmployees]: (state, payload) => ({
    ...state,
    bannedParkingEmployees: payload
  }),
  [actionTypes.setCurrentPage]: (state, payload) => ({
    ...state,
    currentPage: payload
  }),
  [actionTypes.setTotalPages]: (state, payload) => ({
    ...state,
    totalPages: payload
  }),
  [actionTypes.setCurrentSearch]: (state, payload) => ({
    ...state,
    currentSearch: payload
  }),
  [actionTypes.setCurrentStatus]: (state, payload) => ({
    ...state,
    currentStatus: payload
  })
});

export {actionTypes, parkingBansReducer, initialState};
